var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ImageFormat } from './utility';
import { getNumberOfPages, isEncrypted, isCorrupted, getPDFDetail, getPDFVersion } from './muPDFCore';
export function getPDFInfo(file) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const [isEncryptedPDF, isCorruptedPDF, info, pdfVersion, numPages] = yield Promise.all([
                isEncrypted(file),
                isCorrupted(file),
                getPDFDetail(file),
                getPDFVersion(file),
                getNumberOfPages(file),
            ]);
            let isCorrupt = false;
            if (isCorruptedPDF.Corrupted) {
                isCorrupt = true;
            }
            let isEncryption = false;
            if (isEncryptedPDF.PasswordProtected) {
                isEncryption = true;
            }
            return {
                format: ImageFormat.Pdf,
                pdf: {
                    pdfVersion,
                    creator: info.Creator,
                    isCorrupt,
                    pageCount: numPages,
                },
                isError: isCorrupt,
                isSupported: true,
                isEncrypted: isEncryption,
                numPages,
            };
        }
        catch (error) {
            throw new Error(`Some error occurred while getting client-side PDF Info. Error: ${error}`);
        }
    });
}
//# sourceMappingURL=muPDF.js.map